<template>
  <div>
    <UtteranceControl v-bind="$attrs" :disabled-enter="true" v-on="$listeners"></UtteranceControl>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import { UtteranceControl } from '@/components/resources';

@Component({
  components: {
    UtteranceControl
  }
})
export default class SurveyControl extends Vue {}
</script>
